module.exports = __webpack_public_path__ + "static/media/check-icon.88264388.svg";